import React from 'react';
import { connect } from 'react-redux';

import * as device from 'utilities/device';

import FabButton from 'components/ui-components/fab-button';

import './styles.less';

class TrimModeButton extends React.Component {
  static defaultProps = {
    onClick: () => {},
  };

  render() {
    const {
      collaboratePermissions,
      currentUserIsOwner,
      enterTrimEnabled,
      onClick,
      disabled,
      videoIsTeamShared,
    } = this.props;

    return (
      !device.isMobile &&
      (currentUserIsOwner ||
        videoIsTeamShared ||
        collaboratePermissions.write) && (
        <FabButton
          className="trim-mode-button"
          disabled={disabled || !enterTrimEnabled}
          icon="trim-rp"
          onClick={enterTrimEnabled ? onClick : undefined}
        >
          Trim
        </FabButton>
      )
    );
  }
}

const mapStateToProps = state => {
  const {
    player_ready,
    video,
    current_user_is_owner,
    video_is_team_shared: videoIsTeamShared,
  } = state.share_video;

  const { processing_information = {} } = video;
  const { trim_id, trim_progress } = processing_information;

  // the user should be able to enter trim mode if the player is ready or if
  // a trim job is progressing
  const enterTrimEnabled =
    player_ready || (trim_id != null && trim_progress !== 100);

  return {
    collaboratePermissions: video.collaboratePermissions,
    currentUserIsOwner: current_user_is_owner,
    enterTrimEnabled,
    videoIsTeamShared,
  };
};

export default connect(mapStateToProps)(TrimModeButton);
